import type { ImproveNotesTaskId } from '../../contracts/post-note-quality';

export interface PostNoteQualityTaskAnalytics {
  trackTaskCompleted: (taskId: ImproveNotesTaskId, n: number) => void;
  trackTrialDaysUnlocked: (days: number, n: number) => void;
  trackExperienceCompleted: (n: number) => void;
}

export interface PostNoteQualityPorts {
  isPanelEnabled(): boolean;
  invalidateGamifyTrialExtension(): Promise<void>;
  usePostNoteQualityAnalytics(): PostNoteQualityTaskAnalytics;
}

let ports: PostNoteQualityPorts | undefined;

export function configurePostNoteQualityPorts(next: PostNoteQualityPorts): void {
  ports = next;
}

export function getPostNoteQualityPorts(): PostNoteQualityPorts {
  if (ports === undefined) {
    throw new Error('post-note quality ports are not configured');
  }
  return ports;
}
